// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {ButtonLink} from 'sail/Button';
import type {Article} from 'docs/data';
import {createStripeInternalUrl} from 'docs/util';
import {XRaySidebarSection} from './XRaySidebarSection';

type TypeProps = {|
  article: Article,
|};

const getTypeLabel = (type: string) => {
  switch (type) {
    case 'end-to-end':
      return 'End-to-end Guide';
    case 'landing-page':
      return 'Landing Page';
    case 'feature-guide':
      return 'Feature Guide';
    case 'migration-guide':
      return 'Migration Guide';
    case 'how-it-works':
      return 'How it works Guide';
    default:
      return 'Unknown';
  }
};

export const Type = ({article}: TypeProps) => {
  const type = article?.xray?.type;
  const label = getTypeLabel(type || 'unknown');
  if (label === 'Unknown') {
    return null;
  }
  const link = createStripeInternalUrl('site', {
    path: `style-guide/types#${type ?? ''}`,
  });

  return (
    <XRaySidebarSection title="Type">
      <Group direction="horizontal" alignItems="center" spacing={4}>
        <ButtonLink
          label={label}
          href={link}
          icon="external"
          iconPosition="right"
          target="_blank"
        />
      </Group>
    </XRaySidebarSection>
  );
};
